import React, { useState } from "react";

const NewsLetter = () => {
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState(null); // "success", "error", "loading", or null

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Basic email validation
    const isValidEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    if (!isValidEmail) {
      setStatus("error");
      return;
    }

    setStatus("loading");

    // Simulate API call
    setTimeout(() => {
      setStatus("success");
      setEmail("");
    }, 1500);
  };

  return (
    <div className="newsletter-container py-5 bg-light border-top">
      <div className="container text-center">
        <h2 className="mb-3 text-primary-emphasis">
          Subscribe to Our Newsletter
        </h2>
        <p className="mb-4 text-muted">
          Get updates on lab services, health tips, and exclusive offers.
        </p>
        <form onSubmit={handleSubmit} className="row justify-content-center">
          <div className="col-md-6 mb-2">
            <input
              type="email"
              className="form-control"
              placeholder="Enter your email address"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>
          <div className="col-md-2">
            <button
              type="submit"
              className="btn btn-primary w-100"
              disabled={status === "loading"}
            >
              {status === "loading" ? "Subscribing..." : "Subscribe"}
            </button>
          </div>
        </form>

        {/* Feedback Messages */}
        {status === "success" && (
          <div className="mt-3 alert alert-success w-50 mx-auto" role="alert">
            ✅ Subscription successful!
          </div>
        )}
        {status === "error" && (
          <div className="mt-3 alert alert-danger w-50 mx-auto" role="alert">
            ❌ Please enter a valid email.
          </div>
        )}
      </div>
    </div>
  );
};

export default NewsLetter;
